import { render, staticRenderFns } from "./TableCheckbox.vue?vue&type=template&id=0d65d529"
import script from "./TableCheckbox.vue?vue&type=script&lang=js"
export * from "./TableCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TableCheckbox.vue?vue&type=style&index=0&id=0d65d529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports